import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}/api`; //should match the backend URL

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

export const userService = {
  signup: (userData) => api.post('/signup', userData),
  login: (credentials) => api.post('/login', credentials),
  getUser: (userId) => api.get(`/users/${userId}`),
  updateUser: (userId, userData) => api.put(`/users/${userId}`, userData),
  deleteUser: (userId) => api.delete(`/users/${userId}`),
  checkPhoneNumber: async (data) => {
    return await axios.post(`${API_URL}/check-phone`, data);
  },
  sendVerificationCode: async (phoneNumber) => {
    return await api.post('/send-verification', { phone_number: phoneNumber });
  },
  verifyPhoneNumber: async (phoneNumber, code) => {
    return await api.post('/verify-phone', { phone_number: phoneNumber, code });
  },
  forgotPassword: (email) => api.post(`/forgot-password/${email}`),

  getMatches: async (userId) => {
      try {
          const response = await api.get(`${API_URL}/users/${userId}/matches`);
          return response;
      } catch (error) {
          if (error.response) {
              if (error.response.status === 403) {
                  throw new Error("You haven't joined matching yet!");
              }
              const errorMessage = error.response.data?.detail || error.response.statusText;
              throw new Error(errorMessage);
          }
          throw error;
      }
  },
  getVerifiedUsers: () => api.get(`/users/verified`),
  validatePhoneForGroup: (phoneNumber) => api.post(`/users/validate-phone-group`, { phone_number: phoneNumber }),
  getUserGroupMembershipsCount: (userId) => api.get(`/users/${userId}/group-memberships-count`),
};

export const wenziService = {
  createWenzi: async (userId, wenziData) => {
    try {
      return await api.post(`/users/${userId}/wenzis/`, wenziData);
    } catch (error) {
      if (error.response && error.response.status === 400 && error.response.data?.detail?.includes("maximum limit")) {
        throw new Error("You've reached the maximum limit of 3 Wenzis.");
      }
      throw error;
    }
  },
  getWenzis: (userId) => api.get(`/users/${userId}/wenzis/`),
  getWenzi: (wenziId) => api.get(`/wenzis/${wenziId}`),
  updateWenzi: (wenziId, wenziData) => api.put(`/wenzis/${wenziId}`, wenziData),
  deleteWenzi: (wenziId) => api.delete(`/wenzis/${wenziId}`),
  createGroupWenzi: async (wenziData) => {
    try {
      return await api.post(`/wenzis/group/`, wenziData);
    } catch (error) {
      throw error;
    }
  },
};
